import { ActionConstants } from "../constants";
import { server_url } from "constants/types";
import queryString from "query-string";
import { apiCallAction } from "./actionUtils";

export const createInvoiceAction = ({ formData, onSuccess, params = {} }) => {
  return apiCallAction({
    requestMethod: formData?.invoiceId ? "PUT" : "POST",
    requestUrl: `${server_url}/Invoice${
      formData?.invoiceId ? `/${formData.invoiceId}` : ""
    }`,
    requestData: formData,
    actionType: ActionConstants.CREATE_INVOICE,
    successType: ActionConstants.CREATE_INVOICE_SUCCESS,
    errorType: ActionConstants.CREATE_INVOICE_ERROR,
    successCallback: (response, dispatch) => {
      dispatch({
        type: ActionConstants.CREATE_INVOICE_SUCCESS,
        payload: {
          invoiceList: response.data.items,
          totalCount: response.data.totalCount,
        },
      });
      onSuccess();
      dispatch(invoiceGetAllAction(params));
    },
  });
};

export const invoiceGetAllAction = (params) => {
  return apiCallAction({
    requestMethod: "GET",
    requestUrl: `${server_url}/Invoice?${queryString.stringify(params)}`,
    actionType: ActionConstants.INVOICE_GET_ALL,
    successType: ActionConstants.INVOICE_GET_ALL_SUCCESS,
    errorType: ActionConstants.INVOICE_GET_ALL_ERROR,
    successCallback: (response, dispatch) => {
      dispatch({
        type: ActionConstants.INVOICE_GET_ALL_SUCCESS,
        payload: {
          invoiceList: response.data.items,
          totalCount: response.data.totalCount,
        },
      });
    },
  });
};

export const invoiceGetAllActionById = (id) => {
  return apiCallAction({
    requestMethod: "GET",
    requestUrl: `${server_url}/Invoice/${id}`,
    actionType: ActionConstants.INVOICE_GET_BY_ID,
    successType: ActionConstants.INVOICE_GET_BY_ID_SUCCESS,
    errorType: ActionConstants.INVOICE_GET_BY_ID_ERROR,
    successCallback: (response, dispatch) => {
      dispatch({
        type: ActionConstants.INVOICE_GET_BY_ID_SUCCESS,
        payload: {
          invoice: response.data,
        },
      });
    },
  });
};
